import { Column, Row, Section } from '@ydistri/ds';
import CategoryInventoryDefinitionSection from '../../SegmentInventoryDefinition/CategoryInventoryDefinitionSection';
import SegmentCategorySummary from '../../SegmentCategorySummary/SegmentCategorySummary';
import React from 'react';
import CategoryConfigurationHeaderTitle from './CategoryConfigurationHeaderTitle';
import { Divider } from 'antd';
import { styled } from 'styled-components';

interface CategoryConfigurationHeaderProps {
  busy?: boolean;
}

const ThinDivider = styled(Divider)`
  margin-block: 2px 0 !important;
`;

const CategoryConfigurationHeader: React.FC<CategoryConfigurationHeaderProps> = ({ busy }) => {
  return (
    <Section header={<CategoryConfigurationHeaderTitle />} $contentMarginTop={false}>
      <Column $gap="10px">
        <ThinDivider />
        <Row $gap="2rem">
          <CategoryInventoryDefinitionSection fetching={busy} />
          <SegmentCategorySummary />
        </Row>
      </Column>
    </Section>
  );
};

export default CategoryConfigurationHeader;
